import { render, staticRenderFns } from "./CallsType.vue?vue&type=template&id=51822943&"
import script from "./CallsType.vue?vue&type=script&lang=js&"
export * from "./CallsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports